import classNames from 'classnames';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import type { SgBsTheme } from 'state/userPreferences/userPreferences.model';

import { LinkButton } from './LinkButton';

interface ResearchHeaderProps {
  theme: SgBsTheme;
  thematicInsightsUrl: string;
  externalPortalUrl: string;
  macroMattersUrl: string;
}

export const ResearchHeader: FC<ResearchHeaderProps> = ({
  externalPortalUrl,
  macroMattersUrl,
  thematicInsightsUrl,
  theme,
}) => {
  const { formatMessage } = useIntl();

  return (
    <div className="container px-0 mt-4">
      <div className="container px-0 py-4">
        <div className="d-flex justify-content-between align-items-center pe-2">
          <h1 className="mb-0">{formatMessage({ id: 'discover.research.title', defaultMessage: 'Research' })}</h1>
        </div>
      </div>
      <div className="container border-top px-0 py-3">
        <div className="row me-2 pb-xl-3">
          <LinkButton
            title="discover.research.macro.title"
            subtitle="discover.research.macro.subTitle"
            url={macroMattersUrl}
            className="col-6 col-xl-4"
            iconClassName={classNames({
              'bg-east-bay text-white': theme === 'dark',
              'bg-invision-indigo text-white': theme === 'light',
            })}
          >
            <em className="icon icon-lg clickable">forum</em>
          </LinkButton>
          <LinkButton
            title="discover.research.thematics.title"
            subtitle="discover.research.thematics.subTitle"
            url={thematicInsightsUrl}
            className="col-6 col-xl-4"
            iconClassName={classNames({
              'bg-copper-rust text-white': theme === 'dark',
              'bg-invision-yellow': theme === 'light',
            })}
          >
            <em className="icon icon-lg pb-1 clickable">star_outline</em>
          </LinkButton>
          <LinkButton
            title="discover.research.insight.title"
            subtitle="discover.research.insight.subTitle"
            url={externalPortalUrl}
            className="col-12 col-xl-4"
            iconClassName={classNames({
              'bg-plantation text-white': theme === 'dark',
              border: theme === 'light',
            })}
          >
            <span className="text-xxlarge clickable">R&amp;I</span>
          </LinkButton>
        </div>
      </div>
    </div>
  );
};
